import React, { useEffect, useState } from 'react';
import { getDateFormatted } from './NewsUtils.js';
import New from '../New/New';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import './News.css';

const getNews = async (setNews) => {
  fetch('/news').then(async (response) => {
    const responsejson = await response.json();
    const news = get(responsejson, 'items', []);
    const newSorted = news.sort(
      (a, b) =>
        new Date(get(b, 'pubDate', '')) - new Date(get(a, 'pubDate', ''))
    );
    setNews(newSorted);
  });
};

const News = () => {
  const [news, setNews] = useState(null);
  const [numberOfNews, setNumberOfNews] = useState(8);

  useEffect(() => {
    getNews(setNews);
  }, []);

  return (
    <div className="News">
      <div className="News__container">
        <div className="News__title">News</div>
        {isEmpty(news) ? (
          <div className="News__loading">Chargement...</div>
        ) : (
          <>
            <div className="News__news">
              {news.map(
                (news, index) =>
                  index < numberOfNews && (
                    <a
                      href={news.source}
                      key={index}
                      className="News__link"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <New
                        image={get(news, 'image', '')}
                        title={get(news, 'title', '')}
                        pubDate={getDateFormatted(
                          get(news, 'pubDate', '2020-03-16T12:00')
                        )}
                        quote={get(news, 'quote', '')}
                      />
                    </a>
                  )
              )}
            </div>
            {numberOfNews <= news.length && (
              <button
                onClick={() => setNumberOfNews(numberOfNews + 8)}
                className="News__button"
              >
                En charger +
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default News;
